module.exports = __webpack_public_path__ + "assets/img/pdf_1.06095296.png";